import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-aus-verterinary-history-form-info',
  templateUrl: './aus-verterinary-history-form-infos.component.html',
  styleUrls: ['./aus-verterinary-history-form-infos.less']
})
export class AusVerterinaryHistoryFormComponent {
  @Input() noteFields: any[];
  @Input() newNote: any;
  @Input() noteForm: any;
  @Input() yesLabel: string = 'Yes';
  @Input() noLabel: string = 'No';

  getToggleInputName(field: any): string {
    var name = `comments[${field.id}_text]`;
    return name;
  }

  updateTextFieldValue(isSelected: any, field: any) {
    this.newNote[field.name] = isSelected.toString()
    if (!isSelected) {
      this.newNote[`comments[${field.id}_text]`] = ""
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/common/aus-notes/ausVerterinaryHistoryForm.component.ts